import { useId } from '@floating-ui/react';
import { Chip } from '@hologram-dimension/chip';
import { Popover } from '@hologram-dimension/popover';
import { EmptyState } from 'components';
import { FC } from 'react';
import { useStatusMap } from 'utils/hooks';
import clsx from 'clsx/lite';
import styles from './SimStatusChip.module.css';

interface SimStatusChipProps {
  networkState?: string;
  className?: string;
  size?: GetReactParameterBag<typeof Chip>['size'];
  popoverContent?: React.ReactNode;
}

const SimStatusChip: FC<SimStatusChipProps> = ({
  networkState,
  className,
  size,
  popoverContent,
}) => {
  const { statusInfo, isLoading, error } = useStatusMap(networkState);

  const id = useId();

  if (isLoading || error || !statusInfo?.status) {
    return <EmptyState />;
  }

  return (
    <Popover id={id!} content={popoverContent ?? statusInfo.tooltip} className={className}>
      <Chip
        iconStart={statusInfo.icon ?? 'StatusReady'}
        colorVariant={statusInfo.colorVariant}
        className={clsx(styles.chip, size === 'medium' && styles.medium)}
        type="interactive"
        size={size}
      >
        {statusInfo.status}
      </Chip>
    </Popover>
  );
};

export default SimStatusChip;
